module.exports = __webpack_public_path__ + "static/img/gxhdz66.63ad65c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxhdz66.png
// module id = EFrl
// module chunks = 73